import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "./index";
import { installErrorTracking } from "./errors";

/**
 * Records a page view on every route change, and installs the client-error
 * listeners once.
 *
 * Keyed on pathname rather than the whole location so a querystring change
 * (filters, tabs) is not counted as a new page. The dashboard routes off
 * `pathname.split("/")[2]` instead of nested <Route>s, but that still moves the
 * pathname, so its sub-pages are counted like any other.
 */
export const useAnalytics = (): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    installErrorTracking();
  }, []);

  useEffect(() => {
    trackPageview();
  }, [pathname]);
};
